<template>
  <div v-if="products.length" class="quick-keys-section mb-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0 text-muted small text-uppercase">Quick keys</h6>
      <span v-if="source" class="badge akkurate-gray-bg">{{ source }}</span>
    </div>
    <div class="quick-key-grid">
      <button
        v-for="product in products"
        :key="product.id"
        type="button"
        class="quick-key-btn"
        :disabled="(product.stock?.available ?? 0) <= 0"
        @click="$emit('add', product)"
      >
        <span class="quick-key-btn__name">{{ product.name }}</span>
        <span class="quick-key-btn__price">{{ formatMoney(product.unitPrice) }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickKeyGrid",
  props: {
    products: { type: Array, default: () => [] },
    source: { type: String, default: "" },
  },
};
</script>
